import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import { CustomCheckbox } from "../../components/common/CustomCheckbox.js";
import Paper from "@material-ui/core/Paper";
import Style from "../../styles/js/StyleABMCategories.js";
import Typography from "@material-ui/core/Typography";
import { ColorButton } from "../../components/common/CustomButton.js";
import * as ScreenText from "../../consts/ScreenText.js";

export default function CheckboxListSecondary({
  items,
  title,
  onItemClick,
  titleButton,
  handleActivatedChange,
  actionButton,
  showButton,
}) {
  const classes = Style();

  const [selectedIndex, setSelectedIndex] = React.useState();

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
    onItemClick(index);
  };
  return (
    <Paper className={classes.paper}>
      <Typography variant="h6" gutterBottom>
        {title}{" "}
      </Typography>
      {items.length > 0 ? (
        <div className={classes.headerList}>
          <div>{ScreenText.ABM_CATEGORIES_LIST_HEADER_NAME}</div>
          <div>{ScreenText.ABM_CATEGORIES_LIST_HEADER_ACTIVATED}</div>
        </div>
      ) : null}
      <List className={classes.list} dense>
        {items.map((value) => {
          const labelId = `checkbox-list-secondary-label-${value.id}`;
          return (
            <ListItem
              key={value.id}
              button={value.mainCategoryId === undefined}
              selected={selectedIndex === value.id}
              onClick={() =>
                value.mainCategoryId === undefined
                  ? handleListItemClick(value.id)
                  : null
              }
            >
              <ListItemText id={labelId} primary={value.name} />
              <ListItemSecondaryAction>
                <CustomCheckbox
                  edge="end"
                  onChange={() => handleActivatedChange(value)}
                  checked={value.activated}
                />
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
      {showButton ? (
        <ColorButton className={classes.button} onClick={actionButton}>
          {titleButton}
        </ColorButton>
      ) : null}
    </Paper>
  );
}
